import { JSX, useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import CustomSelect from "../../components/CustomSelect";
import PageHeader from "../../components/PageHeader";
import PaginationBar from "../../components/PaginationBar";
import Tabs from "../../components/Tabs";
import QueriesList from "./QueriesList";
import QueriesImport from "./QueriesImport";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useSelector } from "react-redux";
import { fetchQueries } from "../../features/query/QuerySlice";
import useUrlTab from "../../util/hooks/useUrlTab";
import ShareQueriesDropDown from "./ShareQueriesDropDown";
import AddedQuestions from "../query-management-setup/AddedQuestions";
import QueryApis from "../../api/QueryApis";
import { exportToExcel } from "../../util/functions/UniversalFunctions";
import DownloadButton from "../../components/common/DownloadButton";
import { useBranchCode } from "../../util/hooks/useBranch";
import { IS_LIVE } from "../../util/config/env";

const tabOptions = ["Enquiries", 
  // ...(IS_LIVE ? [] : ["Import"]), 
  "Set up"];

export default function Queries() {
  const { activeTab, handleTabChange } = useUrlTab(tabOptions);
  const [statusList, setStatusList] = useState<string[]>([]);

  const dispatch = useDispatch<AppDispatch>();
  const { data, pagination, loading } = useSelector(
    (state: RootState) => state.query,
  );

  const branchCode = useBranchCode();

  useEffect(() => {
    const loadStatus = async () => {
      const result = await QueryApis.queriesStatus();
      if (result?.status === 1 && Array.isArray(result.data)) {
        setStatusList(result.data);
      }
    };

    loadStatus();
  }, []);

  const handleRefresh = () => {
    dispatch(
      fetchQueries({
        page: pagination?.number ?? 0,
        size: pagination?.size ?? 10,
        branchCode,
      }),
    );
  };

  useEffect(() => {
    handleRefresh();
  }, [dispatch, branchCode]);

  const tabContent: Record<string, JSX.Element> = {
    Enquiries: (
      <>
        <QueriesList data={data} loading={loading} onRefresh={handleRefresh} />
      </>
    ),
    Import: (
      <div className="">
        <QueriesImport />
      </div>
    ),
    "Set up": (
      <div className="bg-white px-4 py-5 rounded">
        <AddedQuestions />
      </div>
    ),
  };

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {};

  const navigate = useNavigate();

  const handlePageChange = (newPage: number) => {
    dispatch(
      fetchQueries({ page: newPage, size: pagination?.size || 10, branchCode }),
    );
  };

  const handlePageSizeChange = (newSize: number) => {
    dispatch(fetchQueries({ page: 0, size: newSize, branchCode }));
  };

  const handleDownload = () => {
    if (!data.length) return;

    exportToExcel(data, "Group_List");
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col lg:flex-row justify-between  gap-5">
        <PageHeader title="QUERIES MANAGEMENT" />
        {activeTab === "Enquiries" && (
          <div className="flex flex-col md:flex-row gap-3 justify-end items-end ">
            <div className="flex gap-3">
              <CustomSelect
                name="class"
                value=""
                options={statusList}
                placeholder="Filter by Status.."
                onChange={handleInputChange}
                selectClassName="border-none bg-white "
              />
              <CustomInput
                name="cycle"
                value=""
                type="date"
                placeholder="Select date range"
                onChange={handleInputChange}
                inputClassName="border-none bg-white"
              />
            </div>
            <div className="flex gap-3 justify-end relative items-end">
              <ShareQueriesDropDown />
              <CustomButton
                text="Add Query"
                color="bg-primary-500"
                onClick={() => navigate("/queries/add-query")}
              />
            </div>
          </div>
        )}
        {activeTab === "Set up" && (
          <div className="flex gap-3 justify-end relative items-end">
            <ShareQueriesDropDown />
          </div>
        )}
      </div>
      <div className="flex flex-col md:flex-row md:justify-between gap-2 md:items-center">
        <Tabs
          tabs={tabOptions}
          onTabChange={handleTabChange}
          activeTab={activeTab}
        />
        {activeTab === "Enquiries" && pagination && (
          <div className="flex gap-3 items-center">
            <PaginationBar
              currentPage={pagination.number}
              pageSize={pagination.size}
              totalItems={pagination.totalElements}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
            />
            <DownloadButton
              onClick={handleDownload}
              disabled={loading || data.length === 0}
            />
          </div>
        )}
      </div>
      {tabContent[activeTab]}
    </div>
  );
}
